export function cleanVendorName(incomingName: string) {
  // replace prefixes like "S-1863" and "2460" with ""
  return incomingName
    .replace(/^(\s*(S-)?\d{0,4}(-[a-z]*)?)/, "")
    .replace(/,|\.|:|;|!|\?|&/g, "")
    .replace(
      /(\s*(LLC|L.L.C|Corp|Corporation|Company|Co|Incorporated|Inc|Ltd))$/gi,
      "",
    )
    .trim();
}
